import React, { useEffect, useRef, useState } from 'react';
import { MoreVertical } from 'lucide-react';
import '../styles/RowActions.css';

function RowActions({ actions }) {
  const [open, setOpen] = useState(false);
  const [coords, setCoords] = useState(null);
  const triggerRef = useRef(null);

  // El contenedor de la tabla recorta en horizontal, así que el menú se
  // posiciona en coordenadas de viewport en lugar de dentro de la fila.
  const place = () => {
    const r = triggerRef.current.getBoundingClientRect();
    const width = 184;
    setCoords({
      top: r.bottom + 6,
      left: Math.max(8, Math.min(r.right - width, window.innerWidth - width - 8)),
      width
    });
  };

  useEffect(() => {
    if (!open) return undefined;

    const close = () => setOpen(false);
    const onKey = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };

    window.addEventListener('scroll', close, true);
    window.addEventListener('resize', close);
    document.addEventListener('keydown', onKey);
    return () => {
      window.removeEventListener('scroll', close, true);
      window.removeEventListener('resize', close);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  const toggle = () => {
    if (!open) place();
    setOpen(!open);
  };

  return (
    <>
      <button
        ref={triggerRef}
        className={`btn btn-icon row-actions-trigger ${open ? 'is-open' : ''}`}
        onClick={toggle}
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label="Acciones del registro"
      >
        <MoreVertical size={16} strokeWidth={1.75} />
      </button>

      {open && coords && (
        <>
          <div className="row-actions-backdrop" onClick={() => setOpen(false)} />
          <div
            className="row-actions-menu"
            role="menu"
            style={{ top: coords.top, left: coords.left, width: coords.width }}
          >
            {actions.map(({ label, icon: Icon, onClick, disabled, danger, hint }) => (
              <button
                key={label}
                role="menuitem"
                className={`row-actions-item ${danger ? 'is-danger' : ''}`}
                disabled={disabled}
                title={disabled ? hint : undefined}
                onClick={() => {
                  setOpen(false);
                  onClick();
                }}
              >
                <Icon size={15} strokeWidth={1.75} />
                <span>{label}</span>
                {disabled && <span className="row-actions-hint">Pronto</span>}
              </button>
            ))}
          </div>
        </>
      )}
    </>
  );
}

export default RowActions;
